import { useState, useEffect } from 'react';
import { getRequest } from '../util';

export const useCountryList = () => {
  const endpoint = '/api/checkout/countries';
  const [countryList, setCountryList] = useState([]);

  useEffect(() => {
    let isMounted = true;
    getRequest(endpoint).then((response) => {
      if (isMounted && response.status === 200) {
        console.log('response.data', response.data);
        setCountryList(
          response.data.data.countries.map((d: any) => ({ label: d[0], value: d[1] })),
        );
      }
    });
    return () => {
      isMounted = false;
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return countryList;
};
